import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  IconButton,
  withStyles,
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogContent = withStyles((theme) => ({
  root: {
    '&>div': {
      '&:not(:first-child)': {
        marginTop: theme.spacing(2),
      },
    },
  },
}))(MuiDialogContent);

const StyledDialog = withStyles({
  paper: {
    backgroundColor: '#f2f2f2',
  },
})(Dialog);

const DialogTitle = withStyles(styles)((props) => {
  const {
    children, classes, onClose, ...other
  } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export default ({
  onClose,
  children,
  isOpend = true,
}) => (
  <StyledDialog
    open={isOpend}
    fullWidth
    onClose={onClose}
  >
    <DialogTitle onClose={onClose} />
    <DialogContent>
      {typeof children === 'function' ? children() : children}
    </DialogContent>
    <DialogActions />
  </StyledDialog>
);
